import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-cross",
  "use": "icon-cross-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"icon-cross\"><path d=\"M6.3 5L10 8.7 8.7 10 5 6.3 1.3 10 0 8.7 3.7 5 0 1.3 1.3 0 5 3.7 8.7 0 10 1.3 6.3 5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol